import React from 'react';
import type { DirectCompetitorData } from './types';
import CompetitorCard from './CompetitorCard';

interface DirectCompetitorViewProps {
  competitors: DirectCompetitorData[];
}

const DirectCompetitorView: React.FC<DirectCompetitorViewProps> = ({ competitors }) => {
  if (!competitors || competitors.length === 0) {
    return (
      <div className="text-center py-12 text-gray-400">
        <p>No direct competitors data available</p>
      </div>
    );
  }

  // Get strategic opportunities from first competitor (they all share the same list)
  const strategicOpportunities = competitors[0]?.summary_of_strategic_opportunities
    ? JSON.parse(competitors[0].summary_of_strategic_opportunities)
    : [];

  return (
    <div>
      {/* Strategic Opportunities Section */}
      {strategicOpportunities.length > 0 && (
        <div className="bg-[#2a2a2a] rounded-lg p-6 border border-[#E0E0E021] mb-6">
          {/* <h2 className="text-2xl font-medium text-[#EE4423] mb-2">Direct Competition Analysis</h2> */}
          <h3 className="text-lg font-normal text-white mb-1">Summary of Strategic Opportunities</h3>
          <p className="text-xs text-gray-400 mb-4">
            Key insights and competitive advantages across all competitors
          </p>

          <div className="bg-[#1a1a1a] rounded-lg p-4 border border-[#4a4a4a]">
            <ul className="space-y-3">
              {strategicOpportunities.map((opportunity: string, index: number) => (
                <li key={index} className="flex items-start gap-3 text-gray-300">
                  <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-red-500 mt-2"></span>
                  <span className="text-sm leading-relaxed">{opportunity}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* Competitors List */}
      <div className="space-y-4">
        {competitors.map((competitor) => (
          <CompetitorCard key={competitor.competitor_id} competitor={competitor} />
        ))}
      </div>
    </div>
  );
};

export default DirectCompetitorView;
